export var TournamentLabelType;
(function (TournamentLabelType) {
    TournamentLabelType["LIVE"] = "LIVE";
    TournamentLabelType["TODAY"] = "TODAY";
})(TournamentLabelType || (TournamentLabelType = {}));
